'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import * as React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTransitionStateManager } from "../useTransition/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Demos:
 *
 * - [Transitions](https://mui.com/base-ui/react-transitions/)
 *
 * API:
 *
 * - [CssAnimation API](https://mui.com/base-ui/react-transitions/components-api/#css-animation)
 */ function CssAnimation(props) {
    var children = props.children, className = props.className, enterAnimationName = props.enterAnimationName, enterClassName = props.enterClassName, exitAnimationName = props.exitAnimationName, exitClassName = props.exitClassName, other = _object_without_properties(props, [
        "children",
        "className",
        "enterAnimationName",
        "enterClassName",
        "exitAnimationName",
        "exitClassName"
    ]);
    var _useTransitionStateManager = useTransitionStateManager(), requestedEnter = _useTransitionStateManager.requestedEnter, onExited = _useTransitionStateManager.onExited;
    var hasExited = React.useRef(true);
    React.useEffect(function() {
        if (requestedEnter && hasExited.current) {
            hasExited.current = false;
        }
    }, [
        requestedEnter
    ]);
    var handleAnimationEnd = React.useCallback(function(event) {
        if (event.animationName === exitAnimationName) {
            onExited();
            hasExited.current = true;
        } else if (event.animationName === enterAnimationName) {
            hasExited.current = false;
        }
    }, [
        onExited,
        exitAnimationName,
        enterAnimationName
    ]);
    return /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        onAnimationEnd: handleAnimationEnd,
        className: clsx(className, requestedEnter ? enterClassName : exitClassName)
    }, other), {
        children: children
    }));
}
process.env.NODE_ENV !== "production" ? CssAnimation.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    enterAnimationName: PropTypes.string,
    enterClassName: PropTypes.string,
    exitAnimationName: PropTypes.string,
    exitClassName: PropTypes.string
} : void 0;
export { CssAnimation };
